var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-select",
    {
      staticClass: "style-chooser",
      class: { "t-danger": !_vm.valid },
      attrs: {
        label: "edrpou",
        filterable: false,
        options: _vm.multi_edrpoг_filtered,
      },
      on: { search: _vm.onSearchedrpou, input: _vm.check },
      scopedSlots: _vm._u([
        {
          key: "option",
          fn: function (option) {
            return [
              _c("div", { staticClass: "d-center" }, [
                _vm._v(
                  "\n            " + _vm._s(option.edrpou) + "\n            "
                ),
                _c("small", [_vm._v(_vm._s(option.name))]),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.edrpou,
        callback: function ($$v) {
          _vm.edrpou = $$v
        },
        expression: "edrpou",
      },
    },
    [
      _c("template", { slot: "no-options" }, [
        _vm._v("\n        Починайте вводити номер ЄДРПОУ\n    "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }